import {Type} from '@github-ui/react-query-persister/typebox'
import {Compile} from '@github-ui/react-query-persister/typebox/compile'

/** One term of a view's sort order, by the field's registry identifier. */
export const ViewSortSchema = Type.Object({
  field: Type.String(),
  direction: Type.Union([Type.Literal('asc'), Type.Literal('desc')]),
})
export type ViewSort = Type.Static<typeof ViewSortSchema>

export const ViewConfigurationPayloadSchema = Type.Object({
  layout: Type.Union([Type.Literal('list'), Type.Literal('board')]),
  groupBy: Type.Union([Type.String(), Type.Null()]),
  swimlaneBy: Type.Union([Type.String(), Type.Null()]),
  sorts: Type.ReadonlyObject(Type.Array(ViewSortSchema)),
  visibleFields: Type.ReadonlyObject(Type.Array(Type.String())),
})
export type ViewConfigurationPayload = Type.Static<typeof ViewConfigurationPayloadSchema>

export const viewConfigurationValidator = Compile(ViewConfigurationPayloadSchema)

export function isViewConfiguration(value: unknown): value is ViewConfigurationPayload {
  return viewConfigurationValidator.Check(value)
}
